import React from "react";

const ImageWithInitials = ({ initials, width, background, className, borderRadius }) => {
  return (
    <div
      // className={` ${className}`}
      style={{
        height: `${width}px`,
        width: `${width}px`,
        background: "#3d42de", // background,
        color: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: `${borderRadius ?? '50'}%`,
        fontWeight: "400",

        fontFamily: "Archivo, sans-serif",
        padding: "10px",
        fontSize: `${width > 23 ? 12 : width * 0.5 - 1}px`,
      }}
    >
      <span
        className="d-inline-flex"
        style={{
          opacity: "0.8",
          background: "transparent",
          lineHeight: "13.06px",
        }}
      >
        {initials}
      </span>
    </div>
  );
};

export default ImageWithInitials;
